(function fileWorkflowDefinition() {
    'use strict';
    angular.module('Entities')
        .service('fileWorkflowService', [
            'restUrlBuilder', 'config', '$q',
            function fileWorkflowService(restUrlBuilder, config, $q) {

                restUrlBuilder = restUrlBuilder('wf');

                this.SignDocument = function SignDocument(id, urlCallback, certId, agreement, motive) {
                    var params = { urlRedirect: config.appUrl(urlCallback), certificateId: certId, agreement: agreement, motive: motive };

                    return restUrlBuilder.one('filesGob/SignNacion', id)
                        .get({ params: params });
                };

                this.customerDownload = function (id) {
                    var deferred = $q.defer();

                    restUrlBuilder.all('files/Customer').get({ params: { id: id, audit: true } })
                        .then(function (result) {
                            deferred.resolve(result);
                        },
                            function () {
                                deferred.reject.apply(this, arguments);
                            });

                    return deferred.promise;
                };

                this.preview = function getById(item) {

                    var deferred = $q.defer();

                    restUrlBuilder.one('files', item.id).get()
                        .then(function (result) {
                            deferred.resolve('data:application/pdf;base64,' + result);
                        },
                            function () {
                                deferred.reject.apply(this, arguments);
                            });

                    return deferred.promise;
                };

                this.downloadFilesIntoZip = function downloadFilesIntoZip(files) {
                    var params = { files: files };

                    return restUrlBuilder.all('files/Download').put(params);
                };

                this.downloadFile = function downloadFile(id) {
                    return restUrlBuilder.one('files/Download', id).get();
                };

                this.share = function (processId, certificateTypeId, agreement) {
                    return restUrlBuilder.one('files/Share', processId).one('', certificateTypeId, agreement).get();
                };

                this.shareBulk = function (processIds, certificateTypeId, agreement) {
                    var params = {
                        processIds: processIds,
                        certificateTypeId: certificateTypeId,
                        agreement: agreement
                    };

                    return restUrlBuilder.all('files/BulkShare').put(params);
                };
            }
        ]);
})();